import { IBankNoteList } from '../models/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class ListBankNoteApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/bankNoteList',
      requesterInfo,
    })
  }

  public async listBankNote(): Promise<IBankNoteList[]> {
    return await this.getAsync<IBankNoteList[]>()
  }
}
